/** * Created by lobin on 2019/3/2. */
<template>
  <div class="wechat-login"></div>
</template>

<script type="text/babel">
import { mapActions } from "vuex";
export default {
  data() {
    return {};
  },
  async created() {
    const code = this.$route.query.code;
    if (!code) {
      this.$message.error("code不存在，请重试");
      return this.$router.replace("/");
    }
    const data = await this.wechatLogin(code);
    if (data.code === 200) {
      localStorage.setItem("token", data.data.accessToken);
      this.getInitDate();
    } else {
      this.$message.error(data.message);
    }
    window.location.href = "https://www.itneituiquan.com";
  },
  methods: {
    ...mapActions(["wechatLogin", "getInitDate"])
  }
};
</script>

<style lang="less" rel="stylesheet/less">
.wechat-login {
}
</style>
